import AppModalContainer from '@nxsys/components/AppModalContainer';
import { defaultTheme } from '@nxsys/constants/defaultConfig';
import styled from 'styled-components';
import AwaitingInvoiceGeneration from '../../timesheets/listing/AwaitingInvoiceGeneration';
import GenerateDraftPayroll from '../../timesheets/listing/GenerateDraftPayroll';
import PendingApproval from '../../timesheets/listing/PendingApproval';
import ConfirmPayroll from './ConfirmPayroll';

export enum TimesheetModalTypeEnum {
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  GENERATE_DRAFT_PAYROLL = 'GENERATE_DRAFT_PAYROLL',
  CONFIRM_PAYROLL = 'CONFIRM_PAYROLL',
  PENDING_INVOICE_GENERATION = 'PENDING_INVOICE_GENERATION',
}

type Props = {
  isOpen: boolean;
  toggle: () => void;
  type: TimesheetModalTypeEnum;
  cbAfterAction: () => void;
};

const TimesheetModal: React.FC<Props> = ({
  isOpen,
  toggle,
  type,
  cbAfterAction,
}) => {
  const renderContentByType = () => {
    switch (type) {
      case TimesheetModalTypeEnum.PENDING_APPROVAL:
        return <PendingApproval cbAfterAction={cbAfterAction} isDashboard />;
      case TimesheetModalTypeEnum.GENERATE_DRAFT_PAYROLL:
        return (
          <GenerateDraftPayroll cbAfterAction={cbAfterAction} isDashboard />
        );
      case TimesheetModalTypeEnum.CONFIRM_PAYROLL:
        return <ConfirmPayroll cbAfterAction={cbAfterAction} />;
      case TimesheetModalTypeEnum.PENDING_INVOICE_GENERATION:
        return (
          <AwaitingInvoiceGeneration
            cbAfterAction={cbAfterAction}
            isDashboard
          />
        );
      default:
        return <></>;
    }
  };

  return (
    <AppModalContainer
      title={null}
      isOpen={isOpen}
      toggle={toggle}
      className="max-sm:w-[100vw]"
      width={1250}
      minHeight="0"
      noPaddingBody
      titleFullWidth
    >
      <StyledContentContainer>{renderContentByType()}</StyledContentContainer>
    </AppModalContainer>
  );
};

const StyledContentContainer = styled.div`
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;

  > div > div:nth-child(2) {
    background-color: ${defaultTheme.theme.palette.white};
    min-height: 200px;
    height: fit-content;

    > div > div > div {
      background-color: ${defaultTheme.theme.palette.white};
    }
  }
`;

export default TimesheetModal;
